import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  loading: boolean;
}

const initialState: InitialState = {
  loading: false,
};

export const globalConfig = createSlice({
  name: 'Global',
  initialState,
  reducers: {
    toggle(state, action) {
      state.loading = action.payload;
    },
  },
});
